import React from 'react';
import {
  Flex,
  Heading,
  Icon,
  Text,
} from '@chakra-ui/react';
import { MdSearchOff } from 'react-icons/md';
import { t } from '#i18n';

export const NoDataFound = () => (
  <Flex
    wordBreak="break-word"
    whiteSpace="normal"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    height={48}
  >
    <Icon as={MdSearchOff} color="primary.200" boxSize={12} />
    <Heading size="sm" marginBottom={2}>{t('stats.noDataFound.title')}</Heading>
    <Text textAlign="center">{t('stats.noDataFound.description')}</Text>
  </Flex>
);
